import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Card,
  CardBody,
  Input,
  Form,
  FormGroup,
  Label,
  Spinner,
} from "reactstrap";

import { FaCheckCircle, FaTimesCircle, FaWifi } from "react-icons/fa";
import "../css/CardScan.css";
import PaymentService from "../../../services/OrderingServices/PaymentService";
import { useNavigate } from "react-router-dom";

const CardScanModal = ({ isOpen, toggle, orgCode, paymentData, onSuccess }) => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("idle"); // idle | loading | success | error
  const [paymentResponse, setPaymentResponse] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const macId = localStorage.getItem("macId");
  const terminal = localStorage.getItem("terminal");
  // const orgCode = localStorage.getItem("orgCode");
  const [payload, setPayload] = useState({
    cardUid: "",
    amount: 0,
    referenceId: "",
    kioskId: "",
    metadata: "Testing for demo",
    macId: macId,
    terminal: terminal,
    orgCode: orgCode,
  });
  const inputRef = useRef(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setPayload({ ...payload, [name]: value });
  };

  const handleCardPayment = async () => {
    try {
      setStatus("loading");

      const response = await PaymentService.payWithCard(payload, orgCode);

      setPaymentResponse(response);
      setStatus("success");
    } catch (error) {
      console.error(error);
      setErrorMessage(error.response?.data?.message || "Payment failed");
      setStatus("error");
    }
  };

  const handleClose = () => {
    setStatus("idle");
    setPaymentResponse(null);
    setErrorMessage("");
    toggle();
    navigate(`/${orgCode}`);
  };
  useEffect(() => {
    if (paymentData) {
      setPayload((prev) => ({
        ...prev,
        amount: paymentData.amount,
        referenceId: paymentData.referenceId,
        kioskId: paymentData.kioskId,
      }));
    }
  }, [paymentData]);
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        inputRef.current?.focus();
      }, 300);
    }
  }, [isOpen]);
  useEffect(() => {
    if (status === "success") {
      // setTimeout(async () => {
      if (onSuccess) {
        onSuccess(); // 🔥 call parent flow
        // }
        // handleClose();
        // }, 100);
      }
    }
  }, [status]);
  return (
    <Modal isOpen={isOpen} toggle={handleClose} centered>
      <ModalHeader toggle={handleClose}>
        {status === "idle" && "Tap Card to Pay"}
        {status === "loading" && "Processing Payment..."}
        {status === "success" && "Payment Successful"}
        {status === "error" && "Payment Failed"}
      </ModalHeader>

      <ModalBody className="text-center">
        {status === "idle" && (
          <Card className="border-0 shadow-sm">
            <CardBody className="text-center py-4">
              <div className="rfid-circle mb-3">
                <FaWifi size={40} className="text-primary rfid-icon" />
              </div>
              <h5 className="mt-3">Waiting for Card...</h5>
              <p className="text-muted small">
                Please tap your RFID card on the reader to complete payment.
              </p>

              <form className="mt-3 text-start">
                <FormGroup>
                  <Label for="cardUid">Card UID</Label>
                  <Input
                    innerRef={inputRef}
                    name="cardUid"
                    value={payload.cardUid}
                    onChange={(e) => {
                      handleChange(e);

                      // Auto trigger when UID length reached (example: 10)
                      if (e.target.value.length >= 11) {
                        handleCardPayment(e.target.value);
                      }
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="amount">Amount</Label>
                  <Input
                    type="number"
                    name="amount"
                    value={payload.amount}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="referenceId">Reference ID</Label>
                  <Input
                    name="referenceId"
                    value={payload.referenceId}
                    onChange={handleChange}
                  />
                </FormGroup>
                <FormGroup>
                  <Label for="kioskId">Kiosk ID</Label>
                  <Input
                    name="kioskId"
                    value={payload.kioskId}
                    onChange={handleChange}
                  />
                </FormGroup>
              </form>
            </CardBody>
          </Card>
        )}

        {status === "loading" && (
          <div className="py-5">
            <Spinner color="primary" /> <p className="mt-2">Processing...</p>
          </div>
        )}

        {status === "success" && paymentResponse && (
          <div className="py-3">
            <FaCheckCircle size={80} className="text-success mb-3" />
            <h4 className="text-success fw-bold">Payment Completed</h4>
            <p className="text-muted mt-2">
              The payment has been successfully processed.
            </p>
            <div className="payment-info-box mt-3 p-3">
              <h6 className="mb-1 text-muted">Transaction ID</h6>
              <h3 className="fw-bold">{paymentResponse.data?.transactionId}</h3>
            </div>
            <div className="payment-info-box mt-3 p-3">
              <h6 className="mb-1 text-muted">Amount Paid</h6>
              <h3 className="fw-bold">Rs. {paymentResponse.data?.amount}</h3>
            </div>
            <div className="payment-info-box mt-3 p-3">
              <h6 className="mb-1 text-muted">Remaining Balance</h6>
              <h3 className="fw-bold">
                Rs. {paymentResponse.data?.balanceAfter}
              </h3>
            </div>
          </div>
        )}

        {status === "error" && (
          <div className="py-5">
            <FaTimesCircle size={80} className="text-danger mb-3" />
            <h4 className="text-danger fw-bold">Payment Failed</h4>
            <p className="text-muted mt-2">{errorMessage}</p>
          </div>
        )}
      </ModalBody>

      <ModalFooter className="border-0">
        {status === "idle" && (
          <>
            <Button color="success" onClick={handleCardPayment}>
              Confirm Payment
            </Button>
            <Button color="danger" onClick={handleClose}>
              Cancel
            </Button>
          </>
        )}

        {status === "success" && (
          <Button color="primary" onClick={handleClose}>
            Done
          </Button>
        )}
        {status === "error" && (
          <Button color="primary" onClick={toggle}>
            Retry
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default CardScanModal;
